module.exports = __webpack_public_path__ + "static/media/YF31_2.5e3485f9.jpg";